import {authHeader} from "../helpers/auth-header";

export const listService = {
    listProducts,
    listSupplies,
    listDemands
};

const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json'}
};

function listProducts(){
    return fetch(process.env.VUE_APP_ROOT_API + '/products', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function listSupplies(){
    return fetch(process.env.VUE_APP_ROOT_API + '/supplies', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function listDemands(){
    return fetch(process.env.VUE_APP_ROOT_API + '/demands', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload();
            }
            return Promise.reject(data);
        }

        return data;
    });
}
